export const distanceToSegment = (px, py, x1, y1, x2, y2) => {
  const dx = x2 - x1, dy = y2 - y1;
  const len2 = dx * dx + dy * dy;
  if (len2 === 0) return Math.hypot(px - x1, py - y1);
  let t = ((px - x1) * dx + (py - y1) * dy) / len2;
  t = Math.max(0, Math.min(1, t));
  return Math.hypot(px - (x1 + t * dx), py - (y1 + t * dy));
};

export const getBinanceSymbol = (sym) => {
  if (!sym) return '';
  const s = sym.toUpperCase();
  if (s === 'USDT') return 'USDTUSDC';
  if (s === 'XAU') return 'PAXGUSDT';
  return `${s}USDT`;
};
